import Vue from "vue";

Vue.filter("formatePhone", phone => {
  if (!phone) {
    return "--";
  }
  let arr = phone.toString().split("");
  let str = "";
  arr.forEach((val, i) => {
    if (i === 3 || i === 7) {
      str += "-";
    }
    str += val;
  });
  return str;
});

Vue.filter("formateNumber", number => {
  if (!number && number !== 0) {
    return "--";
  }
  let str = number > 9 ? `${number}` : `0${number}`;
  return str;
});
Vue.filter("dateFilter", val => {
    //依据原始日期格式创建日期对象
    var now = new Date(val);
    var m = now.getMonth() + 1;
    var d = now.getDate();
    //月份与日期 如果当前月份小于10 前拼接0
    m < 10 && (m = "0" + m);
    d < 10 && (d = "0" + d);
    //拼接字符串返回
    return `${m}-${d}`;
});
Vue.filter("datesFilter", val => {
    //依据原始日期格式创建日期对象
    var now = new Date(val);
    //获取日期对象 年月日
    var y = now.getFullYear();
    var m = now.getMonth() + 1;
    var d = now.getDate();
    //月份与日期 如果当前月份小于10 前拼接0
    m < 10 && (m = "0" + m);
    d < 10 && (d = "0" + d);
    //拼接字符串返回
    return `${y}-${m}-${d}`;
});
Vue.filter("datetimeFilter", val => {
    //依据原始日期格式创建日期对象
    var now = new Date(val);
    //获取日期对象 年月日
    var y = now.getFullYear();
    var m = now.getMonth() + 1;
    var d = now.getDate();
    var h = now.getHours();
    var t = now.getMinutes();
    var s =  now.getSeconds();
    //月份与日期 如果当前月份小于10 前拼接0
    m < 10 && (m = "0" + m);
    d < 10 && (d = "0" + d);
    h < 10 && (h = "0" + h);
    t < 10 && (t = "0" + t);
    s < 10 && (s = "0" + s);
    //拼接字符串返回
    return `${y}-${m}-${d} ${h}:${t}:${s}`;
});
